import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import SupportIcon from "@mui/icons-material/Support";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Tooltip from "@mui/material/Tooltip";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ProductHome from "./product/ProductHome";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import SettingsIcon from "@mui/icons-material/Settings";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CustomerHome from "./customer/CustomerHome";
import VendorList from "./vendor/VendorList";
import Dashboard from "./Dashboard/Dashboard";
import PurchaseOrderHome from "./purchase/PurchaseOrderHome";
import AccountingHome from "./Accounting/AccountingHome";
import ReportHomeVertical from "./reports/ReportHomeVertical";
import SettingList from "./setting/SettingList";
import SaleHome from "./sale/SaleHome";
import ISync from "../utils/ISync";
import { Alert, Snackbar } from "@mui/material";
import PAlert from "../components/pos/PAlert";
import PProgressDialog from "../components/pos/PProgressDialog";
import { useTranslation } from "react-i18next";
import AnalyticsHome from "./analytics/AnalyticsHome";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
const drawerWidth = 200;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Home(props) {
  const { t, i18n } = useTranslation();
  const translate = t;
  const [open, setOpen] = React.useState(true);
  const [currentScreen, setCurrentScreen] = React.useState("dashboard");
  const [dataLoaded, setDataLoaded] = React.useState(false);

  const [showSnakbar, setShowSnakBar] = React.useState(false);
  const [alertType, setAlertType] = React.useState("");
  const [alertMessage, setAlertMessage] = React.useState("");

  const [showProgressFlag, setShowProgressFlag] = React.useState(false);
  const [progressMessage, setProgressMessage] = React.useState(false);

  const [alert, setAlert] = React.useState({
    title: "",
    message: "",
    show: false,
  });

  var biRef = {};

  React.useEffect(() => {
    console.log("props.productSearchCache", props.productSearchCache.length);
  }, [props.productCache]);

  function handleSnakClose() {
    setShowSnakBar(false);
  }

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(!open);
  };

  function onListItemClicked(key) {
    console.log("firstList Clicked", key);
  }

  function onLogOut() {
    localStorage.removeItem("w_accessToken");
    localStorage.removeItem("w_refreshToken");
    props.setCurrentPage("login");
  }

  function onDataLoaded() {
    setDataLoaded(true);
    if (props.context.store.expiry && props.context.store.expiry < 0) {
      setAlert({
        show: true,
        type: props.context.store.expiry * -1 > 30 ? "model" : "normal",
        title: translate("Warning!"),
        message: translate(
          "Your licence got expired " +
            props.context.store.expiry * -1 +
            " days back, Please contact support immediately"
        ),
      });
    } else if (props.context.store.expiry && props.context.store.expiry < 30) {
      setAlert({
        show: true,
        title: translate("Warning!"),
        message: translate(
          "Your licence will expire in " +
            props.context.store.expiry +
            " days, Please contact support immediately"
        ),
      });
    }
  }

  async function showMessage(type, message) {
    setAlertType(type);
    setAlertMessage(message);
    setShowSnakBar(true);

    await sleep(3000);
    setShowSnakBar(false);
  }
  let sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  function showProgress(message) {
    setProgressMessage(message);
    setShowProgressFlag(true);
  }

  function hideProgress() {
    setShowProgressFlag(false);
  }

  function queueRefresh(data) {
    console.log("queuRefresh", data);
  }

  return (
    <div>
      {dataLoaded && (
        <Box sx={{ display: "flex" }}>
          <CssBaseline />
          {/*<AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: "36px",
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            eSale POS
          </Typography>
        </Toolbar>
          </AppBar>*/}
          <Drawer
            variant="permanent"
            open={open}
            PaperProps={{
              sx: {
                backgroundColor: "#262628",
                color: "white",
                width: 100,
              },
            }}
          >
            <DrawerHeader>
              {open && "ESALE POS"}
              <IconButton onClick={handleDrawerClose}>
                {!open && <ChevronRightIcon style={{ color: "white" }} />}
                {open && <ChevronLeftIcon style={{ color: "white" }} />}
              </IconButton>
            </DrawerHeader>
            <Divider />
            <List>
              <ListItem
                button
                key={"dashboard"}
                style={{
                  backgroundColor:
                    currentScreen === "dashboard" ? "#00acc1" : "#262628",
                }}
                onClick={() => {
                  setCurrentScreen("dashboard");
                }}
              >
                <ListItemIcon>
                  <Tooltip title="Dashboard">
                    <DashboardIcon style={{ color: "white" }}></DashboardIcon>
                  </Tooltip>
                </ListItemIcon>
                <ListItemText primary={translate("Dashboard")} />
              </ListItem>
              {props.context.privileges.menu_sale && (
                <ListItem
                  key={"sale"}
                  style={{
                    backgroundColor:
                      currentScreen === "sale" ? "#00acc1" : "#262628",
                  }}
                  onClick={() => {
                    setCurrentScreen("sale");
                  }}
                >
                  <ListItemIcon>
                    <Tooltip title="Point of Sale">
                      <ShoppingCartIcon
                        style={{ color: "white" }}
                      ></ShoppingCartIcon>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary={translate("POS")} />
                </ListItem>
              )}
              {props.context.privileges.menu_product && (
                <ListItem
                  button
                  key={"productHome"}
                  style={{
                    backgroundColor:
                      currentScreen === "productHome" ? "#00acc1" : "#262628",
                  }}
                  onClick={() => {
                    setCurrentScreen("productHome");
                  }}
                >
                  <ListItemIcon>
                    <Tooltip title="Product">
                      <LocalOfferIcon
                        style={{ color: "white" }}
                      ></LocalOfferIcon>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary={translate("Product")} />
                </ListItem>
              )}
              {props.context.privileges.menu_customer && (
                <ListItem
                  button
                  key={"customer"}
                  style={{
                    backgroundColor:
                      currentScreen === "customer" ? "#00acc1" : "#262628",
                  }}
                  onClick={() => {
                    setCurrentScreen("customer");
                  }}
                >
                  <ListItemIcon>
                    <Tooltip title="Custtomer">
                      <SupervisorAccountIcon
                        style={{ color: "white" }}
                      ></SupervisorAccountIcon>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary={translate("Customer")} />
                </ListItem>
              )}
              {props.context.privileges.menu_vendor && (
                <ListItem
                  button
                  key={"vendor"}
                  style={{
                    backgroundColor:
                      currentScreen === "vendor" ? "#00acc1" : "#262628",
                  }}
                  onClick={() => {
                    setCurrentScreen("vendor");
                  }}
                >
                  <ListItemIcon>
                    <Tooltip title="Vendors">
                      <SupportIcon style={{ color: "white" }}></SupportIcon>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary={translate("Vendors")} />
                </ListItem>
              )}
              {props.context.privileges.menu_purchase && (
                <ListItem
                  button
                  key={"purchase"}
                  style={{
                    backgroundColor:
                      currentScreen === "purchaseHome" ? "#00acc1" : "#262628",
                  }}
                  onClick={() => {
                    setCurrentScreen("purchaseHome");
                    if (biRef && biRef.purchaseOrderHome)
                      biRef.purchaseOrderHome.parentEvent("returnHome");
                  }}
                >
                  <ListItemIcon>
                    <Tooltip title="Inventory">
                      <LocalShippingIcon
                        style={{ color: "white" }}
                      ></LocalShippingIcon>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary={translate("Inventory")} />
                </ListItem>
              )}
              {props.context.privileges.menu_account && (
                <ListItem
                  button
                  key={"accounts"}
                  style={{
                    backgroundColor:
                      currentScreen === "accountHome" ? "#00acc1" : "#262628",
                  }}
                  onClick={() => {
                    setCurrentScreen("accountHome");
                    if (biRef && biRef.AccountingHome)
                      biRef.AccountingHome.parentEvent("returnHome");
                  }}
                >
                  <ListItemIcon>
                    <Tooltip title="Accounts">
                      <AccountBalanceIcon
                        style={{ color: "white" }}
                      ></AccountBalanceIcon>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary={translate("Accounts")} />
                </ListItem>
              )}
              {/*props.context.privileges.menu_reports && (
                <ListItem
                  button
                  key={"Reports"}
                  style={{
                    backgroundColor:
                      currentScreen === "analytics" ? "#00acc1" : "#262628",
                  }}
                  onClick={() => {
                    setCurrentScreen("analytics");
                  }}
                >
                  <ListItemIcon>
                    <Tooltip title="Analytics">
                      <AutoGraphIcon style={{ color: "white" }}></AutoGraphIcon>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary={translate("Analytics")} />
                </ListItem>
                )*/}
              {props.context.privileges.menu_reports && (
                <ListItem
                  button
                  key={"Reports"}
                  style={{
                    backgroundColor:
                      currentScreen === "reports" ? "#00acc1" : "#262628",
                  }}
                  onClick={() => {
                    setCurrentScreen("reports");
                  }}
                >
                  <ListItemIcon>
                    <Tooltip title="Reports">
                      <TrendingUpIcon
                        style={{ color: "white" }}
                      ></TrendingUpIcon>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary={translate("Reports")} />
                </ListItem>
              )}
              {props.context.privileges.menu_settings && (
                <ListItem
                  button
                  key={"settings"}
                  style={{
                    backgroundColor:
                      currentScreen === "settings" ? "#00acc1" : "#262628",
                  }}
                  onClick={() => {
                    setCurrentScreen("settings");
                  }}
                >
                  <ListItemIcon>
                    <Tooltip title="Settings">
                      <SettingsIcon style={{ color: "white" }}></SettingsIcon>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary={translate("Settings")} />
                </ListItem>
              )}
              <ListItem
                button
                key={"logout"}
                style={{
                  backgroundColor:
                    currentScreen === "logout" ? "#00acc1" : "#262628",
                }}
                onClick={() => {
                  onLogOut();
                }}
              >
                <ListItemIcon>
                  <Tooltip title="logout">
                    <PowerSettingsNewIcon
                      style={{ color: "white" }}
                    ></PowerSettingsNewIcon>
                  </Tooltip>
                </ListItemIcon>
                <ListItemText primary={translate("Logout")} />
              </ListItem>
            </List>
            <Divider />
          </Drawer>
          <Box
            component="main"
            sx={{ flexGrow: 1, p: "5px", background: "#fafafa" }}
          >
            {currentScreen === "dashboard" && (
              <Dashboard context={props.context}></Dashboard>
            )}
            {currentScreen === "sale" && (
              <SaleHome
                context={props.context}
                onLogOut={onLogOut}
                showMessage={showMessage}
                setAlert={setAlert}
                setCurrentPage={setCurrentScreen}
                showProgress={showProgress}
                hideProgress={hideProgress}
                setProgressMessage={setProgressMessage}
                userName={props.userName}
                productCache={props.productSearchCache}
                productCache2={props.productCache}
              ></SaleHome>
            )}
            {currentScreen === "productHome" && (
              <ProductHome
                showMessage={showMessage}
                setAlert={setAlert}
                showProgress={showProgress}
                hideProgress={hideProgress}
                setProgressMessage={setProgressMessage}
                context={props.context}
                productCache={props.productCache}
              ></ProductHome>
            )}
            {currentScreen === "customer" && (
              <CustomerHome
                context={props.context}
                showMessage={showMessage}
                setAlert={setAlert}
              ></CustomerHome>
            )}
            {currentScreen === "vendor" && (
              <VendorList
                context={props.context}
                showMessage={showMessage}
                setAlert={setAlert}
              ></VendorList>
            )}
            {currentScreen === "purchaseHome" && (
              <PurchaseOrderHome
                context={props.context}
                showMessage={showMessage}
                setAlert={setAlert}
                biRef={biRef}
                productCache={props.productCache}
                productSearchCache={props.productSearchCache}
              ></PurchaseOrderHome>
            )}
            {currentScreen === "accountHome" && (
              <AccountingHome
                context={props.context}
                showMessage={showMessage}
                setAlert={setAlert}
                biRef={biRef}
                showProgress={showProgress}
                hideProgress={hideProgress}
              ></AccountingHome>
            )}
            {currentScreen === "analytics" && (
              <AnalyticsHome
                context={props.context}
                showMessage={showMessage}
                setAlert={setAlert}
              ></AnalyticsHome>
            )}
            {currentScreen === "reports" && (
              <ReportHomeVertical
                context={props.context}
                showMessage={showMessage}
                setAlert={setAlert}
                showProgress={showProgress}
                hideProgress={hideProgress}
              ></ReportHomeVertical>
            )}{" "}
            {currentScreen === "settings" && (
              <SettingList
                context={props.context}
                showMessage={showMessage}
                setAlert={setAlert}
                showProgress={showProgress}
                hideProgress={hideProgress}
              ></SettingList>
            )}
          </Box>
        </Box>
      )}
      <ISync
        baseUrl={props.baseUrl}
        onDataLoaded={onDataLoaded}
        onLogOut={onLogOut}
        context={props.context}
        setContext={props.setContext}
        showMessage={showMessage}
        setAlert={setAlert}
        queueRefresh={queueRefresh}
        setProductCache={props.setProductCache}
        setProductSearchCache={props.setProductSearchCache}
      ></ISync>

      <Snackbar
        open={showSnakbar}
        onClose={handleSnakClose}
        message={alertMessage}
        style={{ height: "100%" }}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
      >
        <Alert
          onClose={handleSnakClose}
          severity={alertType}
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      {alert.show && (
        <PAlert alert={alert} open={alert.show} setAlert={setAlert}></PAlert>
      )}
      {showProgressFlag && (
        <PProgressDialog message={progressMessage}></PProgressDialog>
      )}
    </div>
  );
}
